import React from "react";
import { Conversation } from "@/services/chat";
import { ConversationItem } from "./ConversationItem";
import { Loader2 } from "lucide-react";

interface ConversationListProps {
  conversations: Conversation[];
  selectedConversationId?: string;
  onSelectConversation: (id: string) => void;
  loading?: boolean;
  userRole: string | null;
}

export const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  selectedConversationId,
  onSelectConversation,
  loading = false,
  userRole
}) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-full p-6">
        <Loader2 className="h-6 w-6 text-[#00B6F0] animate-spin" />
      </div>
    );
  }
  
  if (conversations.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center p-6">
        <p className="text-gray-400">
          Nenhuma conversa iniciada ainda.
        </p>
      </div>
    );
  }
  
  return (
    <div className="h-full overflow-y-auto">
      <div className="space-y-1">
        {conversations.map(conversation => (
          <ConversationItem
            key={conversation.id}
            conversation={conversation}
            isSelected={selectedConversationId === conversation.id}
            onClick={() => onSelectConversation(conversation.id)}
            userRole={userRole}
          />
        ))}
      </div>
    </div>
  );
};
